module.exports = __webpack_public_path__ + "27e58e0929d1c95671615ffd282143bd.png";